import {Component, OnDestroy} from "@angular/core";
import {BreadcrumbModel} from "../../../models/misc/breadcrumb.model";
import {HeaderTitleService} from "../../../../service/services/misc/header-title/header-title.service";
import {Const, ResourceType} from "../../../helpers/Const";
import {ResourceModel} from "../../../models/resources/resource.model";
import {ActivatedRoute} from "@angular/router";
import {firstValueFrom, Subscription} from "rxjs";
import {Utils} from "../../../helpers/Utils";
import {UisService} from "../../../../service/services/misc/uis/uis.service";
import {FolderService} from "../../../../service/services/rest/folder/folder.service";
import {OrganizationService} from "../../../../service/services/rest/organization/organization.service";
import {LocationStrategy} from "@angular/common";

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: false
})
export class BreadcrumbsComponent implements OnDestroy {

    private readonly LOAD_AMOUNT = 100;
    readonly SHOW_SEARCH_THRESHOLD = 5;
    Utils = Utils;
    ResourceType = ResourceType;
    breadcrumbs$ = this._headerTitleService.breadcrumbs;
    const = Const;
    resourceType = ResourceType;
    subscriptions: Subscription[] = [];
    currentPath: string;
    fixedType = 'type';
    sortFn: (a: any, b: any, ascending: boolean) => number;
    currentAmount = 50;
    searchTerm = '';
    isPaginatedView = false;
    constructor(private _headerTitleService: HeaderTitleService, private _route: ActivatedRoute,
        private folderService: FolderService,  private organizationService: OrganizationService, private uisService: UisService, private _location: LocationStrategy) {
        this.subscriptions.push(
            this._route.queryParams.subscribe((params) => {
                this.currentPath = params['path'];
            })
        );
    }

    shouldDisplay(): boolean {
        return this._location.path().startsWith("/project");
    }

    getSiblings(breadcrumb: BreadcrumbModel): ResourceModel[] {
        return breadcrumb.siblings || [];
    }

    getPath(path: string) {
        let match = path.match(/\/.*?\/(.*)/);
        if (match) {
            return '/' + match[1];
        } else {
            return '';
        }
    }

    loadMore() {
        this.currentAmount += this.LOAD_AMOUNT;
    }

    async loadMoreLazy(breadcrumb: BreadcrumbModel) {
        if (breadcrumb.type === ResourceType.ORGANIZATION) {
            await this.loadOrganizations(breadcrumb, false);
        }
    }

    getOrg(path: string) {
        return path.split('/')[1];
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }

    getRouterLink(item: ResourceModel, breadcrumb: BreadcrumbModel) {
        if(breadcrumb.type === ResourceType.ORGANIZATION) {
            return '/project/_all/organizations/' + item.name;
        } else {
            return '/project/_all/organizations/' + this.getOrg(item.path) + (item.type === ResourceType.FOLDER ? '/folders' : '/resource-groups');
        }
    }

    async doSearch(searchString: string, breadcrumb: BreadcrumbModel) {
        this.searchTerm = searchString;
        if (!this.isPaginatedView) {
            return;
        }

        if (breadcrumb.type === ResourceType.ORGANIZATION) {
            breadcrumb.continueToken = "";
            await this.loadOrganizations(breadcrumb, true);
        }
    }

    async onOpenChange(isOpen: boolean, breadcrumb: BreadcrumbModel) {
        this.searchTerm = '';
        this.isPaginatedView = false;
        if (!isOpen) {
            return;
        }
        if ((!breadcrumb.type || !!breadcrumb.siblings?.length) && breadcrumb.siblings?.length === breadcrumb.totalCount) {
            return;
        }

        if (breadcrumb.type === ResourceType.ORGANIZATION){
            breadcrumb.siblings = [];
            breadcrumb.continueToken = "";
            await this.loadOrganizations(breadcrumb, true);

            this.isPaginatedView = !!breadcrumb.continueToken;

        } else {
            await this.loadContainers(breadcrumb);
        }
        breadcrumb.totalCount = breadcrumb.siblings?.length || 0;
    }

    async loadContainers(breadcrumb: BreadcrumbModel) {
        try {
            breadcrumb.loading = true;
            let result = breadcrumb.index === 0 ?
                await firstValueFrom(this.organizationService.getContainers(breadcrumb.path)) :
                await firstValueFrom(this.folderService.getContainers(breadcrumb.path));
            breadcrumb.siblings = result.filter(item => item.name !== breadcrumb.name);
        } finally {
            breadcrumb.loading = false;
        }
    }

    async loadOrganizations(breadcrumb: BreadcrumbModel, reset: boolean) {
        try {
            breadcrumb.loading = true;
            const organizationsPage = await firstValueFrom(this.organizationService
                .getPage(this.LOAD_AMOUNT, this.searchTerm, "displayName", true, breadcrumb.continueToken));
            if (reset) {
                breadcrumb.siblings = [];
            }
            breadcrumb.siblings = [...breadcrumb.siblings, ...organizationsPage.data];
            breadcrumb.continueToken = organizationsPage.continueToken;
        } catch(e) {
            //Do nothing
        } finally {
            breadcrumb.loading = false;
        }
    }

    breadcrumbNavigate(breadcrumb: BreadcrumbModel) {
        this.uisService.sendUISEvent(this.uisService.UIS_EVENT_TYPES.BREADCRUMBS_NAVIGATION
            + " - " + (breadcrumb.type ? breadcrumb.type : "root") , {type: (breadcrumb.type ? breadcrumb.type : "root")});
    }

}
